import axios from 'axios'
import { woTermUrl, getHeader } from '@/config'

const state = {
  woTermList: []
}

const mutations = {
  SET_WORK_ORDER_TERM_LIST (state, obj) {
    state.woTermList = obj
  }
}

const actions = {
  getWoTermList: ({ commit }) => {
    axios.get(woTermUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_WORK_ORDER_TERM_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
